export default "__VITE_ASSET__D7QYF_sN__"